import { Fragment, useEffect, useState } from 'react'
import { Dialog, Transition } from '@headlessui/react'
import { XCircleIcon, XIcon } from '@heroicons/react/solid'
import axios from "axios";
import IsAuth from '../../utillityComponents/IsAuth';
import HasPermission from '../../utillityComponents/HasPermission';
import { ADMIN_API_URL } from '../../api/axios';

const paymentTypeOptions = [
  { value: 'mobilepay', label: 'MobilePay' },
  { value: 'credit_card', label: 'Kortbetaling (Stripe)' },
  { value: 'transfer', label: 'Bankoverførsel' },
  { value: 'invoice', label: 'Faktura' },
];

const parseApiError = (err) => {
  const data = err?.response?.data;
  if (data?.error) return typeof data.error === 'string' ? data.error : JSON.stringify(data.error);
  if (data?.message) return data.message;
  if (data) return JSON.stringify(data);
  return err?.message || 'Der opstod en uventet fejl';
};

export default function UpdateSponsor(props) {
  const [open, setOpen] = useState(props.show)

  const [firstName, setFirstName] = useState('')
  const [lastName, setLastName] = useState('')
  const [email, setEmail] = useState('')
  const [tlf, setTlf] = useState('')
  const [newStartnr, setNewStartnr] = useState(null)
  const [startnr, setStartnr] = useState('')
  const [showSelect, setShowSelect] = useState(false)
  const [donateOnce, setDonateOnce] = useState('')
  const [donateKm, setDonateKm] = useState('')
  const [paymentType, setPaymentType] = useState('')
  const [newPaymentType, setNewPaymentType] = useState('')
  const [sendEmail, setSendEmail] = useState(false)
  const [sponsorId, setSponsorId] = useState('')
  const [paymentFail, setPaymentFail] = useState(false)
  const [confirmPayment, setConfirmPayment] = useState(false)
  const [confirmPaymentFail, setConfirmPaymentFail] = useState(false)
  const [error, setError] = useState(null)
  const isAdmin = IsAuth(['Admin'])
  const canSendMobilepay = isAdmin || HasPermission(['Send_mobilepay'])

  useEffect(() => {
    if (!props.show) return;
    setError(null);
    setPaymentFail(false);
    setConfirmPayment(false);
    setConfirmPaymentFail(false);
    setShowSelect(false);
    setNewStartnr(null);
    setSendEmail(false);
    if (props.sponsorId !== undefined) {
      getSponsor(props.sponsorId);
    }
    setOpen(true);
    // eslint-disable-next-line
  }, [props.show])

  const uploadAxios = axios.create({
    headers: {
        Authorization: 'Bearer ' + localStorage.getItem('aT'),
        'Content-Type': 'application/json',
    },
  });

  const getSponsor = async ( old_id ) => {
    try {
      const response = await uploadAxios.get(ADMIN_API_URL + '/sponsor/get/'+old_id);
      setFirstName(response.data.first_name)
      setLastName(response.data.last_name)
      setEmail(response.data.email)
      setTlf(response.data.phone_number)
      setStartnr(response.data.participant_startnr)
      setDonateOnce(response.data.donation_fixed)
      setDonateKm(response.data.donation_km)
      setPaymentType(response.data.payment_type)
      setNewPaymentType(response.data.payment_type)
      setSponsorId(response.data.id)
    } catch (err) {
        console.error(err);
        setError(parseApiError(err));
    }
    setShowSelect(true)
  }

  const startBilling = async (confirmPayment, sponsorId) => {
    if (confirmPayment == false) {
      setConfirmPaymentFail(true)
      return
    }
    try {
      if (paymentType === 'mobilepay') {
        await uploadAxios.post(ADMIN_API_URL + '/sponsor/' + sponsorId + '/mobilepay/send');
      } else {
        await uploadAxios.post(ADMIN_API_URL + '/sponsor/startBilling/'+sponsorId);
      }
      setOpen(false)
    } catch (err) {
        setPaymentFail(true)
        setConfirmPaymentFail(false)
        console.error(err);
        setError(parseApiError(err));
    }
  }

  const handleSubmitPaticipant = async (e) => {
    e.preventDefault();
    let isMounted = true;
    const controller = new AbortController();

    const saveEdit = async () => {
      try {
        await uploadAxios.patch(ADMIN_API_URL + '/sponsor/update/'+props.sponsorId, {
          first_name: firstName,
          last_name: lastName,
          email: email,
          phone_number: tlf,
          participant_startnr: startnr,
          new_start_nr: newStartnr,
          donation_fixed: donateOnce,
          donation_km: donateKm,
          send_email: sendEmail,
          ...(newPaymentType !== paymentType ? { payment_type: newPaymentType } : {}),
        });
        isMounted && setOpen(false);
      } catch (err) {
          console.error(err);
          setError(parseApiError(err));
      }
    }

    saveEdit()

    return () => {
      isMounted = false;
      controller.abort();
  }
  }

  const deleteEvent = async ( old_id ) => {
    try {
      await uploadAxios.delete(ADMIN_API_URL + '/sponsor/delete/'+old_id);
      console.log('delete event')
      setOpen(false)
    } catch (err) {
        console.error(err);
        setError(parseApiError(err));
    }
  }

  return (
    <Transition.Root show={open} as={Fragment}>
      <Dialog as="div" className="fixed z-10 inset-0 overflow-y-auto" onClose={setOpen}>
        <div className="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <Dialog.Overlay className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
          </Transition.Child>

          <span className="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">
            &#8203;
          </span>
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            enterTo="opacity-100 translate-y-0 sm:scale-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100 translate-y-0 sm:scale-100"
            leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
          >
            <div className="relative inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-2xl sm:w-full">
              {/* Header */}
              <div className="flex items-center justify-between px-6 py-4 border-b border-gray-200">
                <Dialog.Title as="h3" className="text-lg font-semibold text-gray-900">
                  Rediger Sponsor
                </Dialog.Title>
                <button
                  type="button"
                  className="rounded-md text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                  onClick={() => setOpen(false)}
                >
                  <XIcon className="h-5 w-5" aria-hidden="true" />
                </button>
              </div>

              <div className="px-6 py-4 max-h-[calc(100vh-200px)] overflow-y-auto">
                {error && (
                  <div className="mb-4 rounded-md bg-red-50 p-4">
                    <div className="flex">
                      <div className="flex-shrink-0">
                        <XCircleIcon className="h-5 w-5 text-red-400" aria-hidden="true" />
                      </div>
                      <div className="ml-3 flex-1">
                        <p className="text-sm text-red-700">{error}</p>
                      </div>
                      <div className="ml-auto pl-3">
                        <button type="button" onClick={() => setError(null)} className="inline-flex rounded-md bg-red-50 p-1.5 text-red-500 hover:bg-red-100">
                          <XIcon className="h-5 w-5" aria-hidden="true" />
                        </button>
                      </div>
                    </div>
                  </div>
                )}

                <form id="update-sponsor-form" onSubmit={handleSubmitPaticipant}>
                  {/* Section: Sponsor detaljer */}
                  <div className="mb-6">
                    <h4 className="text-base font-semibold text-gray-900 border-b pb-2 mb-4">Sponsor detaljer</h4>
                    <div className="space-y-4">
                      <div className="sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start">
                        <label htmlFor="first-name" className="block text-sm font-medium text-gray-700 sm:mt-px sm:pt-2">
                          Fornavn
                        </label>
                        <div className="mt-1 sm:mt-0 sm:col-span-2">
                          <input
                            type="text"
                            name="first-name"
                            id="first-name"
                            onChange={(e) => setFirstName(e.target.value)}
                            value={firstName}
                            className="block w-full shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm border-gray-300 rounded-md"
                            required
                          />
                        </div>
                      </div>

                      <div className="sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start">
                        <label htmlFor="last-name" className="block text-sm font-medium text-gray-700 sm:mt-px sm:pt-2">
                          Efternavn
                        </label>
                        <div className="mt-1 sm:mt-0 sm:col-span-2">
                          <input
                            type="text"
                            name="last-name"
                            id="last-name"
                            onChange={(e) => setLastName(e.target.value)}
                            value={lastName}
                            className="block w-full shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm border-gray-300 rounded-md"
                            required
                          />
                        </div>
                      </div>

                      <div className="sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start">
                        <label htmlFor="email" className="block text-sm font-medium text-gray-700 sm:mt-px sm:pt-2">
                          Email
                        </label>
                        <div className="mt-1 sm:mt-0 sm:col-span-2">
                          <input
                            type="email"
                            name="email"
                            id="email"
                            onChange={(e) => setEmail(e.target.value)}
                            value={email}
                            className="block w-full shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm border-gray-300 rounded-md"
                            required
                          />
                        </div>
                      </div>

                      <div className="sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start">
                        <label htmlFor="tlf" className="block text-sm font-medium text-gray-700 sm:mt-px sm:pt-2">
                          Mobilnummer
                        </label>
                        <div className="mt-1 sm:mt-0 sm:col-span-2">
                          <input
                            type="tel"
                            name="tlf"
                            id="tlf"
                            onChange={(e) => setTlf(e.target.value)}
                            value={tlf}
                            className="block w-full shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm border-gray-300 rounded-md"
                            required
                          />
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Section: Deltager & Donation */}
                  <div className="mb-6">
                    <h4 className="text-base font-semibold text-gray-900 border-b pb-2 mb-4">Deltager & Donation</h4>
                    <div className="space-y-4">
                      <div className="sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start">
                        <label htmlFor="participant" className="block text-sm font-medium text-gray-700 sm:mt-px sm:pt-2">
                          Deltager
                        </label>
                        <div className="mt-1 sm:mt-0 sm:col-span-2">
                          {showSelect ?
                            <select
                              id="participant"
                              name="participant"
                              onChange={(e) => setNewStartnr(e.target.value)}
                              className="block w-full pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm rounded-md"
                              defaultValue={startnr}
                            >
                              <option key="0" disabled></option>
                              {props.participantsList.map((participant) => (
                                <option key={participant.startnr} value={participant.startnr}>{participant.name}</option>
                              ))}
                            </select>
                          : null}
                        </div>
                      </div>

                      <div className="sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start">
                        <label htmlFor="donate_km" className="block text-sm font-medium text-gray-700 sm:mt-px sm:pt-2">
                          Donationer: Kr/km
                        </label>
                        <div className="mt-1 sm:mt-0 sm:col-span-2">
                          <input
                            type="number"
                            name="donate_km"
                            id="donate_km"
                            onChange={(e) => setDonateKm(e.target.value)}
                            value={donateKm}
                            className="block w-full shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm border-gray-300 rounded-md"
                            required
                          />
                        </div>
                      </div>

                      <div className="sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start">
                        <label htmlFor="donate_once" className="block text-sm font-medium text-gray-700 sm:mt-px sm:pt-2">
                          Donationer: Fast beløb
                        </label>
                        <div className="mt-1 sm:mt-0 sm:col-span-2">
                          <input
                            type="number"
                            name="donate_once"
                            id="donate_once"
                            onChange={(e) => setDonateOnce(e.target.value)}
                            value={donateOnce}
                            className="block w-full shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm border-gray-300 rounded-md"
                            required
                          />
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Section: Betalingsmetode (Admin og NGO) */}
                  {IsAuth(['Admin', 'Ngo']) ?
                    <div className="mb-6">
                      <h4 className="text-base font-semibold text-gray-900 border-b pb-2 mb-4">Betalingsmetode</h4>
                      <div className="sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start">
                        <label htmlFor="payment_type" className="block text-sm font-medium text-gray-700 sm:mt-px sm:pt-2">
                          Betaler med
                        </label>
                        <div className="mt-1 sm:mt-0 sm:col-span-2">
                          <select
                            id="payment_type"
                            name="payment_type"
                            value={newPaymentType}
                            onChange={(e) => setNewPaymentType(e.target.value)}
                            className="block w-full pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm rounded-md"
                          >
                            {paymentTypeOptions.map((option) => (
                              <option key={option.value} value={option.value}>{option.label}</option>
                            ))}
                          </select>
                          {newPaymentType !== paymentType && (
                            <p className="mt-2 text-sm text-yellow-700">
                              Når du gemmer, annulleres en åben MobilePay- eller kortanmodning, så sponsoren ikke kan betale to gange.
                              Anmodninger der er afvist eller udløbet røres ikke. En betaling der allerede er gennemført kan ikke flyttes.
                            </p>
                          )}
                        </div>
                      </div>
                    </div>
                  : null}

                  {/* Section: Betaling (Admin; MobilePay also for users with the Send_mobilepay permission) */}
                  {isAdmin || (canSendMobilepay && paymentType === 'mobilepay') ?
                    <div className="mb-6">
                      <h4 className="text-base font-semibold text-gray-900 border-b pb-2 mb-4">Betaling</h4>
                      <div className="space-y-4">
                        <div className="flex items-center justify-between p-3 rounded-lg border border-gray-200">
                          <label className="flex items-center space-x-3 cursor-pointer">
                            <input
                              type="checkbox"
                              defaultChecked={confirmPayment}
                              onChange={(e) => setConfirmPayment(e.target.checked)}
                              className="focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded"
                            />
                            <span className="text-sm font-medium text-gray-700">Bekræft betaling</span>
                          </label>
                          {paymentType === 'invoice' || paymentType === 'credit_card' ?
                            <p className="text-sm text-gray-500">
                              {paymentType === 'invoice' ? 'Fakturaer bekræftes som betalt på sponsorsiden.' : 'Kortbetalinger sendes automatisk.'}
                            </p>
                          : !paymentFail ?
                            <button
                              type="button"
                              className="inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-indigo-600 text-sm font-medium text-white hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                              onClick={() => startBilling(confirmPayment, sponsorId)}
                            >
                              {paymentType === 'mobilepay' ? 'Send Mobilepay' : paymentType === 'transfer' ? 'Send Overførsels mail' : 'Send'}
                            </button>
                          :
                            <p className="text-red-500 text-xs italic">{error || 'Har allerede modtaget betaling'}</p>
                          }
                        </div>
                        {paymentType === 'mobilepay' && (
                          <p className="text-xs text-gray-500">Sender en ny MobilePay-anmodning. En åben anmodning annulleres først, så sponsoren ikke kan betale to gange.</p>
                        )}
                        {confirmPaymentFail && (
                          <p className="text-red-500 text-sm">Du skal bekræfte betaling for at kunne udsende</p>
                        )}
                      </div>
                    </div>
                  : null}

                  {/* Section: Farezone */}
                  <div className="mb-2">
                    <h4 className="text-base font-semibold text-red-600 border-b border-red-200 pb-2 mb-4">Farezone</h4>
                    <div className="p-4 rounded-lg border border-red-200 bg-red-50">
                      <div className="flex items-center justify-between">
                        <span className="text-sm font-medium text-red-700">Slet denne sponsor permanent</span>
                        <button
                          type="button"
                          className="inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-red-600 text-sm font-medium text-white hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500"
                          onClick={() => deleteEvent(props.sponsorId)}
                        >
                          Slet Sponsor
                        </button>
                      </div>
                    </div>
                  </div>
                </form>
              </div>

              {/* Sticky footer */}
              <div className="sticky bottom-0 bg-white border-t border-gray-200 px-6 py-4 sm:flex sm:flex-row-reverse sm:items-center sm:gap-3">
                <button
                  type="submit"
                  form="update-sponsor-form"
                  className="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-indigo-600 text-base font-medium text-white hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:w-auto sm:text-sm"
                >
                  Gem
                </button>
                <button
                  type="button"
                  className="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:mt-0 sm:w-auto sm:text-sm"
                  onClick={() => setOpen(false)}
                >
                  Annuller
                </button>
                <label className="mt-3 flex items-center space-x-2 cursor-pointer sm:mt-0 sm:mr-auto">
                  <input
                    type="checkbox"
                    checked={sendEmail}
                    onChange={(e) => setSendEmail(e.target.checked)}
                    className="focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded"
                  />
                  <span className="text-sm text-gray-700">Send ændringer i email</span>
                </label>
              </div>
            </div>
          </Transition.Child>
        </div>
      </Dialog>
    </Transition.Root>
  )
}
